module.exports = __webpack_public_path__ + "static/new_retention_options-59b4b91a157d4386dd95c75515455e71.png";